/** Impls dos use cases de Atividades. @since H.2 */
import type {
  Assignment, UpsertAssignmentCommand, ListAssignmentsParams,
  AssignmentSubmission, CorrigirSubmissionCommand,
} from '@/domain/model/Assignment';
import type { AssignmentGateway } from '@/application/port/out/AssignmentGateway';
import type {
  ListAssignmentsUseCase, CreateAssignmentUseCase, UpdateAssignmentUseCase,
  PublishAssignmentUseCase, EncerrarAssignmentUseCase, ArquivarAssignmentUseCase,
  ListAssignmentSubmissionsUseCase, CorrigirSubmissionUseCase, DownloadSubmissionArquivoUseCase,
} from '@/application/port/in/AssignmentUseCase';

export class ListAssignments implements ListAssignmentsUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(params: ListAssignmentsParams): Promise<Assignment[]> { return this.g.list(params); }
}
export class CreateAssignment implements CreateAssignmentUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(cmd: UpsertAssignmentCommand): Promise<Assignment> { return this.g.create(cmd); }
}
export class UpdateAssignment implements UpdateAssignmentUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(id: string, cmd: UpsertAssignmentCommand): Promise<Assignment> { return this.g.update(id, cmd); }
}
export class PublishAssignment implements PublishAssignmentUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(id: string): Promise<Assignment> { return this.g.publicar(id); }
}
export class EncerrarAssignment implements EncerrarAssignmentUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(id: string): Promise<Assignment> { return this.g.encerrar(id); }
}
export class ArquivarAssignment implements ArquivarAssignmentUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(id: string): Promise<void> { return this.g.arquivar(id); }
}
export class ListAssignmentSubmissions implements ListAssignmentSubmissionsUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(assignmentId: string): Promise<AssignmentSubmission[]> { return this.g.listSubmissions(assignmentId); }
}
export class CorrigirSubmission implements CorrigirSubmissionUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(submissionId: string, cmd: CorrigirSubmissionCommand): Promise<AssignmentSubmission> {
    return this.g.corrigirSubmission(submissionId, cmd);
  }
}
export class DownloadSubmissionArquivo implements DownloadSubmissionArquivoUseCase {
  constructor(private readonly g: AssignmentGateway) {}
  execute(submissionId: string): Promise<Blob> { return this.g.baixarArquivoSubmission(submissionId); }
}
